// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3UEll","requiredAsterisk":"Info_requiredAsterisk__2YZcC"};